<template>
  <div
    :class="getLoading && 'bg-white'"
    class="flex-auto px-4 lg:px-6 py-6 pt-0"
  >
    <div
      v-if="getLoading"
      class="bg-white w-full flex flex-col py-10 justify-center items-center"
    >
      <!-- https://gannon.tv/intro -->
      <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
      <h3>Loading...</h3>
    </div>
    <form v-if="!getLoading">
      <div class="flex justify-between items-center pr-4">
        <h6
          class="pl-4 text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase"
        >
          Basic
        </h6>
        <button
          @click="handleAddSlides"
          type="button"
          class="bg-gray-500 text-white active:bg-gray-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
        >
          Add Slides
        </button>
      </div>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                title="Instance Name"
                description="The name of the instance"
              />
            </label>
          </div>
          <input
            v-model="formDataLocal['slider']['instance_name']"
            type="text"
            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
          />
        </div>
        <div
          v-for="(value, name) in sliderAttrbutes"
          :key="name"
          class="w-full lg:w-4/12 px-4"
        >
          <div v-if="value.type === 'short_text'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              type="text"
              v-model="formDataLocal['slider']['attributes'][`${name}`]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div
            v-else-if="value.type === 'select' || value.type === 'boolean'"
            class="relative w-full mb-3"
          >
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <select
              v-model="formDataLocal['slider']['attributes'][`${name}`]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            >
              <option
                v-for="(option, index) in changeOptionsFormat(value.options)"
                :key="index"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div v-else-if="value.type === 'url'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <URLInput
              :url="
                formDataLocal['slider']['attributes'][`${name}`]
                  ? formDataLocal['slider']['attributes'][`${name}`]
                  : ''
              "
              @update:url="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else-if="value.type === 'icon'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <IconPicker
              :icons="value.options"
              :icon="
                formDataLocal['slider']['attributes'][`${name}`]
                  ? formDataLocal['slider']['attributes'][`${name}`]
                  : ''
              "
              @update:icon="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              v-model="formDataLocal['slider']['attributes'][`${name}`]"
              type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
        <div
          class="w-full px-4"
          v-for="(value, index) in formDataLocal['slider']['attributes'][
            'slides'
          ]"
          :key="index"
        >
          <SlidePanel
            v-if="formDataLocal[index]"
            :index="String(index)"
            :formData="formData"
            :slideOptions="slideOptions"
            :handleDelete="handleDeleteSlides"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import URLInput from "@/components/Shared/Input/URLInput";
import IconPicker from "@/components/Shared/Input/IconPicker";
import SlidePanel from "@/components/ComponentModule/ImageSliderComponent/SlidePanel";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";

export default {
  name: "ImageSliderCreatePageForm",
  components: {
    SlidePanel,
    URLInput,
    IconPicker,
    AttrTitleWithDescription
  },
  props: {
    formData: {
      type: Object,
      requried: true
    }
  },
  watch: {
    sliderAttrbutes() {
      // when slider attributes exist, autofill the form data with empty value
      if (this.slideAttributes && Object.keys(this.sliderAttrbutes).length) {
        Object.keys(this.slideAttributes).forEach((item) => {
          if (!this.formDataLocal["slider"]["attributes"][item]) {
            this.formDataLocal["slider"]["attributes"][item] =
              this.slideAttributes[item].value;
          }
        });
      }
    }
  },
  computed: {
    // slide options used for select box on slide panel component
    slideOptions() {
      if (this.getSlideInstance && Object.keys(this.getSlideInstance).length) {
        return this.getSlideInstance.map((item) => {
          return { label: item.instance_name.split("|")[1], value: item.id };
        });
      } else {
        return [];
      }
    },
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    sliderAttrbutes() {
      if (this.getAllAttributes) {
        let { slides, ...params } = this.getAllAttributes;// eslint-disable-line
        return params;
      }
      return {};
    },
    ...mapGetters([
      "getLoading",
      "getAllAttributes",
      "getAllComponent",
      "getSlideInstance"
    ])
  },
  methods: {
    formatAttrName(name) {
      const nameArray = name.split("_");
      nameArray.splice(0, 2);
      return nameArray.join(" ");
    },
    changeOptionsFormat(options) {
      const newOptions = options.map((item) => {
        return { label: item, value: item };
      });
      return newOptions;
    },
    handleAddSlides() {
      // push a new slide object into formData
      this.formDataLocal["slider"]["attributes"]["slides"].push({
        instance: ""
      });
      // create an object to store slide instance data
      this.formDataLocal[
        this.formDataLocal["slider"]["attributes"]["slides"].length - 1
      ] = {
        hotspots: []
      };
    },
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    },
    handleDeleteSlides(index) {
      this.formDataLocal["slider"]["attributes"]["slides"] = this.formDataLocal[
        "slider"
      ]["attributes"]["slides"].filter((item, i) => {
        return i !== index;
      });
    },
    handleUpdateValue(val, name) {
      this.formDataLocal["slider"][name] = val;
    }
  }
};
</script>
